var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "step-card rounded h-100 w-100 pa-20 pa-md-30 py-lg-54 d-flex flex-column align-center text-center"
  }, [_c('sub-icon-primary', {
    attrs: {
      "spacing": "mb-14 mb-lg-20",
      "bgColor": "#fff",
      "size": "icon-priamry--lg",
      "icon": _vm.icon
    }
  }), _c('div', {
    staticClass: "step-card__step d-flex align-center justify-center line-height-1 mb-16 mb-lg-34"
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold color-white text-center"
  }, [_vm._v(" STEP " + _vm._s(_vm.step) + " ")])]), _c('h4', {
    staticClass: "tit--sm font-weight-bold mb-4 mb-lg-10"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")]), _c('p', {
    staticClass: "page-text color-grey"
  }, [_vm._v(" " + _vm._s(_vm.sc1) + " ")]), _vm.sc2 ? _c('p', {
    staticClass: "page-text color-grey mt-2 mt-lg-6"
  }, [_vm._v(" " + _vm._s(_vm.sc2) + " ")]) : _vm._e(), _vm.sc3 ? _c('p', {
    staticClass: "page-text color-grey mt-2 mt-lg-6"
  }, [_vm._v(" " + _vm._s(_vm.sc3) + " ")]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }